/* eslint-disable check-file/filename-blocklist */
export enum CoreInvitesSource {
	UNKNOWN = 'unknown',
	MENTION = 'mention',
	PEOPLE_MENU = 'peopleMenu',
	ONBOARDING_INVITE_FLAG = 'onboarding-invite-flag',
	PERSISTENT_INVITE_PAGETREE = 'pageTree',
	PERSISTENT_INVITE_HOMESCREEN = 'homeScreen',
	CONTEXTUAL_INVITE_NUDGE = 'onboarding-contextual-invite-nudge',
	CONTEXTUAL_INVITE_NUDGE_IMPROVED = 'onboarding-contextual-invite-nudge-improved',
	LIVE_PAGES_NUDGE = 'onboarding-contextual-invite-live-pages-nudge',
	SHARE_DIALOG = 'share-dialog',
	SHARE_AND_RESTRICT_DIALOG = 'share-and-restrict-dialog',
	IBO_TAKEOVER_INVITE = 'onboarding-takeover-invite-people',
	EA_DROPDOWN = 'ea-dropdown',
	HOME_ONBOARDING_TAKEOVER_V2 = 'home-onboarding-takeover-v2',
	CROSS_JOIN = 'virality-cross-join',
	OPEN_MODAL_QUERY_PARAM = 'open-modal-query-param',
}
